"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkInfo = {
    host: 'npmjs.com',
    version: '9.1.1',
    name: '@kentico/kontent-delivery'
};
//# sourceMappingURL=sdk-info.generated.js.map